import { TTranslationKey } from 'src/app/project/features/translate/types';
import { EIconPath } from '../../../shared/enums/icons.enum';
import { EExportFormat } from '../utils/export-page-format-enum';
import { EExportTypeName } from '../utils/export-type-names-enum';

export type TExportOutputFormat = {
  label: string;
  value: EExportFormat;
};

export type TExportImageSizes = {
  label: string;
  value: EExportImageSize;
};

export enum EExportImageSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LARGE_SCALED = 'largeScaled',
  EXTRA_LARGE = 'extraLarge',
  EXTRA_LARGE_SCALED = 'extraLargeScaled',
}

export type TExportType = {
  label: string;
  pngIcon: string;
  value: EExportTypeName;
  enable: boolean;
  outputFormat?: TExportOutputFormat[];
  extension: string;
  caption?: string;
  isEditible?: boolean;
};

export type TExportTypeTranslation = {
  label: TTranslationKey;
  pngIcon: string;
  value: EExportTypeName;
  enable: boolean;
  outputFormat?: TExportOutputFormat[];
  extension: string;
  caption?: TTranslationKey;
  isEditible?: boolean;
};

export type TExportTypeGroup = {
  label: TTranslationKey;
  description: TTranslationKey;
  items: TExportTypeTranslation[];
};

const outputPrintSize = [
  { label: 'A4', value: EExportFormat.A4 },
  { label: 'Letter', value: EExportFormat.LETTER },
];

const outputPrintSize__sitePlan = [
  { label: 'A4', value: EExportFormat.A4 },
  { label: 'A3', value: EExportFormat.A3 },
  { label: 'Letter', value: EExportFormat.LETTER },
  { label: 'Legal', value: EExportFormat.LEGAL },
];

export const imageSizes = [
  { label: 'Small', value: EExportImageSize.SMALL },
  { label: 'Medium', value: EExportImageSize.MEDIUM },
  { label: 'Large', value: EExportImageSize.LARGE },
  { label: 'Large – Original Ratio', value: EExportImageSize.LARGE_SCALED },
  { label: 'Extra Large', value: EExportImageSize.EXTRA_LARGE },
  { label: 'Extra Large – Original Ratio', value: EExportImageSize.EXTRA_LARGE_SCALED },
];

const pdfIconSrc = EIconPath.EXPORT_PDF;
const excelIcon = EIconPath.EXPORT_EXCEL;
const wordIconSrc = EIconPath.EXPORT_WORD;
const mapIconSrc = EIconPath.EXPORT_PLAN;

export const PDFSummary: TExportTypeTranslation = {
  label: 'pdf_summary' as TTranslationKey,
  pngIcon: pdfIconSrc,
  value: EExportTypeName.SIMPLE_LIST,
  enable: true,
  outputFormat: outputPrintSize,
  extension: 'pdf',
  caption: 'PDF_summary_caption',
  isEditible: false,
};

export const PDFFullReport: TExportTypeTranslation = {
  label: 'pdf' as TTranslationKey,
  pngIcon: pdfIconSrc,
  value: EExportTypeName.DETAILED_LIST,
  enable: true,
  outputFormat: outputPrintSize,
  extension: 'pdf',
  caption: 'PDF_full_report_summary',
  isEditible: false,
};

export const excelOutput: TExportTypeTranslation = {
  label: 'excel' as TTranslationKey,
  pngIcon: excelIcon,
  value: EExportTypeName.XLSX,
  extension: 'xlsx',
  enable: true,
  caption: 'excel_caption',
  isEditible: true,
};

export const pdfIndividualReport: TExportTypeTranslation = {
  label: 'pdf' as TTranslationKey,
  pngIcon: pdfIconSrc,
  value: EExportTypeName.PDF_ZIP,
  enable: true,
  outputFormat: outputPrintSize,
  extension: 'pdf',
  caption: 'pdf_individual_report_caption',
};

export const pdfSingleIndividualReport: TExportTypeTranslation = {
  label: 'pdf' as TTranslationKey,
  pngIcon: pdfIconSrc,
  value: EExportTypeName.PDF,
  enable: true,
  outputFormat: outputPrintSize,
  extension: 'pdf',
  caption: 'pdf_individual_report_single_caption',
};

export const wordFullReport: TExportTypeTranslation = {
  label: 'word' as TTranslationKey,
  pngIcon: wordIconSrc,
  value: EExportTypeName.WORD,
  enable: true,
  outputFormat: outputPrintSize,
  extension: '',
  isEditible: true,
  caption: 'word_full_report_caption',
};

export const wordSummary: TExportType = {
  label: 'WORD - Summary',
  pngIcon: wordIconSrc,
  value: EExportTypeName.WORD_SIMPLE,
  enable: true,
  outputFormat: outputPrintSize,
  extension: '',
  caption: 'Separate report for each site with essential details',
  isEditible: true,
};

export const wordIndividual: TExportTypeTranslation = {
  label: 'word_individual_summary' as TTranslationKey,
  pngIcon: wordIconSrc,
  value: EExportTypeName.WORD_SIMPLE,
  enable: true,
  outputFormat: outputPrintSize,
  extension: '',
  caption: 'word_individual_summary_caption',
  isEditible: true,
};

export const sitePlan: TExportType = {
  label: 'Site Plan',
  pngIcon: mapIconSrc,
  value: EExportTypeName.SITE_PLAN,
  enable: true,
  extension: 'pdf',
  outputFormat: outputPrintSize__sitePlan,
};

export const sitePlanPDF: TExportTypeTranslation = {
  label: 'pdf' as TTranslationKey,
  pngIcon: pdfIconSrc,
  value: EExportTypeName.SITE_PLAN,
  enable: true,
  extension: 'pdf',
  outputFormat: outputPrintSize__sitePlan,
  caption: 'site_plan_caption',
  isEditible: false,
};
